import "core-js/modules/es.array.map.js";
export var getIndexedOptions = function getIndexedOptions(indexed) {
  return indexed.map(function (item) {
    return {
      id: item.id,
      label: item.name
    };
  });
};